import * as analytics from 'analytics/Analytics';
import {SCHEMAS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {SchemaValidationErrorRecord} from 'schemas/SchemaValidationConstants';

export function isIntegrationField(field: {isIntegration: boolean}): boolean {
  return field.isIntegration;
}

export function sendReviewBlockingAnalytics(errors: Array<SchemaValidationErrorRecord>): void {
  const integrationFieldErrors = errors.filter((err) => err.field && isIntegrationField(err.field));
  if (integrationFieldErrors.length) {
    const allErrorsIntegration = errors.length === integrationFieldErrors.length;
    analytics.deprecatedTrackEvent(SCHEMAS_ANALYTICS_ACTIONS.INTEGRATION_FIELD_BLOCKED_REVIEW, {
      allErrorsIntegration,
    });
  }
}
